import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import OrgSearchPicker from "./OrgSearchPicker";
import SystemUsersTable from "./SystemUsersTable";

// Rendered as a Manage Team tab (see ManageTeamDetails.js) — only ever visible to accounts
// holding systemUsers:VIEW/MANAGE ("Ascend Cargo System Admin"), since the backing menu is a
// child of manageTeam and getAllowedManageTeamTabs only surfaces tabs the caller's privileges
// actually grant. Search any organization on the platform, then manage its system (integration)
// users — same "search any org" pattern Preferred Partners already uses, just cross-tenant here
// instead of scoped to already-linked partners.
const SystemUsersTab = () => {
    const [selectedOrg, setSelectedOrg] = useState(null);

    if (!selectedOrg) {
        return <OrgSearchPicker onSelect={setSelectedOrg} />;
    }

    return (
        <div className="space-y-fluid-3">
            <div className="flex items-center gap-fluid-2 flex-wrap bg-gray-50 dark:bg-acs-dark-hover border border-gray-200 dark:border-acs-dark-border rounded-xl px-fluid-3 py-fluid-2">
                <button
                    onClick={() => setSelectedOrg(null)}
                    className="flex items-center gap-1.5 shrink-0 px-fluid-2 py-1 rounded-lg border border-[#223688] dark:border-[#3B5CCC] text-[#223688] dark:text-[#3B5CCC] text-fluid-sm font-semibold hover:bg-[#223688] hover:text-white dark:hover:bg-[#3B5CCC] dark:hover:text-[#1A1C23] transition"
                >
                    <ArrowLeft size={14} /> Change organization
                </button>
                <span className="text-fluid-sm text-gray-600 dark:text-acs-dark-subtext">Managing system users for </span>
                <span className="text-fluid-sm font-semibold text-[#111827] dark:text-acs-dark-text">{selectedOrg.name}</span>
                <span className="text-fluid-sm text-gray-500 dark:text-acs-dark-subtext">({selectedOrg.officeCode})</span>
            </div>
            <SystemUsersTable officeCode={selectedOrg.officeCode} officeName={selectedOrg.name} />
        </div>
    );
};

export default SystemUsersTab;
